import { BodyContent } from './layout/body'
import { HeadContent } from './layout/head'

export const OurDifferenceContent = () => {
  return (
    <div>
      <HeadContent />
      <BodyContent />
    </div>
  )
}
